var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgConnecticut(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "288px",
    height: "288px",
    viewBox: "0 0 288 288",
    style: {
      enableBackground: "new 0 0 288 288"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.639,136.957l4.35-6.378l-22.178-86.374l-0.76-2.963l-84.994,22.926l-20.014,0.87l-8.407,1.75L37.972,82.566 l12.165,71.615l7.578,44.599l10.442,13.052l-23.204,21.758l13.271,12.255c0-0.018,7.903-1.504,8.482-1.949 c0.579-0.441,1.451-7.403,6.093-7.986c4.641-0.58,8.12-0.58,10.717-5.802c2.626-5.22,6.977-14.801,11.019-13.345 c4.058,1.452,4.949,2.285,5.225,1.579c0.305-0.718,1.157-12.316,5.816-11.15c4.621,1.16,1.432,4.632,4.913,3.471 c3.483-1.158,16.825-29.013,19.727-29.013c2.898,0,1.338,8.13,3.426,8.993c2.083,0.879,6.435-5.586,11.367-6.421 c4.928-0.834,7.545-0.323,8.412,0c0.871,0.327,18.852-4.314,20.592-4.895c1.742-0.578,7.834-7.253,11.623-6.971 c3.752,0.296,3.461-0.299,5.205-0.008c1.736,0.304-2.034-12.744-4.932-13.036c-2.902-0.291-1.738-6.964,2.879-4.354 c4.66,2.613,6.693,7.824,7.564,10.728c0.867,2.9,2.9,6.386,7.248,2.039c4.35-4.357,4.063-7.261,8.119-7.544 c4.066-0.296,7.549,0.861,7.838-0.879c0.289-1.749-6.094-8.129-5.223-11.31c0.852-3.2,6.962-7.835,7.252-4.644 c0.293,3.19,0.578,11.604,2.32,11.885c1.741,0.296,4.641-2.901,8.412-4.642c3.768-1.739,10.73-2.316,11.893-0.872 c1.16,1.453,5.225-4.062,5.225-4.062L243.639,136.957z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnecticut);
export default __webpack_public_path__ + "static/media/connecticut.f0e135173d08fd76548c0bf0743e6a59.svg";
export { ForwardRef as ReactComponent };